import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import type { JobPostsQueryMetadata } from '~/api/jobPosts/types';

import { jobPostsQueryOptions, useJobPosts } from '~/api/jobPosts/useJobPosts';
import { Card, LinkButton, Title } from '~/components';
import { headerStyle, listStyle, rootStyle } from '~/pages/Dashboard/JobPostsSummary/jobPostsSummary.css';
import { JobPostCard } from '~/pages/JobPosts/components/JobPostCard';
import { JobPostsList } from '~/pages/JobPosts/components/JobPostsList';
import { routes } from '~/providers/RouterProvider/router.routes';

const queryMetadata: JobPostsQueryMetadata = {
  activityIds: [],
  locationType: null,
  pagination: { pageIndex: 0, pageSize: 3 },
  regions: [],
};

export const JobPostsSummary = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['dashboard']);

  const { data: jobPostsResponse, isError, isPending, isPlaceholderData } = useJobPosts(queryMetadata);

  const jobPosts = jobPostsResponse?.data ?? [];

  return (
    <Card.Root className={rootStyle} render={<section />}>
      <div className={headerStyle}>
        <Title as="h2" styleAs="h3">
          {t('dashboard:jobPostsSummary.title')}
        </Title>

        <LinkButton emphasis="tertiary" icon="ArrowRight" iconPlacement="right" to={routes.jobPosts}>
          {t('dashboard:jobPostsSummary.link')}
        </LinkButton>
      </div>
      {!isError ? (
        <JobPostsList className={listStyle} isLoading={isPending || isPlaceholderData} length={3} responsive={false}>
          {jobPosts.map((jobPost) => (
            <li key={jobPost.id}>
              <JobPostCard jobPost={jobPost} />
            </li>
          ))}
        </JobPostsList>
      ) : (
        <Card.Error
          onRetry={() => queryClient.resetQueries(jobPostsQueryOptions(queryMetadata))}
          title={t('dashboard:jobPostsSummary.error')}
        />
      )}
    </Card.Root>
  );
};
